import { RestUrl } from "../common/cyan.types";

export class InventoryUrl {
  public static getInventoryBalance: RestUrl = ["GET", "/inventory/balance"];
  public static getInventoryBalanceByUserId: (userId: bigint) => RestUrl = userId => ["GET", `/users/${userId}/inventory/balance`];
}
